import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Modal } from 'components/Feedback';
import { FormSection } from 'components/FormSection';
import { Button, Select, TextField } from 'components/Inputs';
import { Container, Item, Row } from 'components/Layout';

const errorState = {
  nameError: false,
  boardIdError: false
};

export const ModalForm = props => {
  const { config, onNext, onClose, connections } = props;
  const initialState = {};

  const [{ name, connexionId, boardId }, setState] = React.useState(
    initialState
  );
  const [{ nameError, boardIdError, connectionError }, setError] = useState(
    errorState
  );

  const handleChange = key => value => {
    setState(prevState => {
      const states = { ...prevState };
      states[key] = value;
      return states;
    });
  };

  const handleError = key => value => {
    setError(prevState => {
      const states = { ...prevState };
      states[key] = value;
      return states;
    });
  };

  const resetStates = () => {
    setState(initialState);
  };

  const onValidate = async () => {
    let error = false;
    if (!name) {
      handleError('nameError')(true);
      error = true;
    }
    if (!boardId) {
      handleError('boardIdError')(true);
      error = true;
    }
    if (!connexionId) {
      handleError('connectionError')(true);
    }
    if (!error) {
      const data = { name, boardId, connexionId };
      onNext(data);
      resetStates();
    }
  };

  const getActions = () => {
    return (
      <Container>
        <Row spacing={1}>
          <Item xs justify="flex-end">
            <Button
              variant="contained"
              size="medium"
              widthSize="medium"
              onClick={onValidate}
            >
              {config ? 'Actualiser' : 'Créer'} le board
            </Button>
          </Item>
        </Row>
      </Container>
    );
  };

  return (
    <Modal
      actions={getActions()}
      {...props}
      onClose={() => {
        resetStates();
        onClose();
      }}
    >
      <Container>
        <Row spacing={1}>
          <Item justify="flex-start">
            <FormSection title="Général" xs={3}>
              <Container>
                <Row spacing={0} justify="flex-start">
                  <Item xs={6} justify="flex-start">
                    <Container>
                      <Row spacing={0} justify="flex-start">
                        <Item xs={11} justify="flex-start">
                          <TextField
                            small
                            title="Id de board (Monday)"
                            required
                            value={boardId}
                            onChange={handleChange('boardId')}
                            error={boardIdError}
                          />
                        </Item>
                      </Row>
                    </Container>
                  </Item>
                  <Item xs={6} justify="flex-start">
                    <Container>
                      <Row spacing={0} justify="flex-start">
                        <Item xs={11} justify="flex-start">
                          <TextField
                            title="Nom de board"
                            required
                            small
                            value={name}
                            onChange={handleChange('name')}
                            error={nameError}
                          />
                        </Item>
                      </Row>
                    </Container>
                  </Item>
                  <Item xs={6} justify="flex-start">
                    <Container>
                      <Row spacing={0} justify="flex-start">
                        <Item xs={11} justify="flex-start">
                          <Select
                            required
                            options={connections.map(connection => {
                              return {
                                label: connection.name,
                                value: connection.id
                              };
                            })}
                            value={connexionId}
                            error={connectionError}
                            onChange={handleChange('connexionId')}
                            title="Connexion"
                          />
                        </Item>
                      </Row>
                    </Container>
                  </Item>
                </Row>
              </Container>
            </FormSection>
          </Item>
        </Row>
      </Container>
    </Modal>
  );
};

ModalForm.defaultProps = {
  onClose: () => null
};
ModalForm.propTypes = {
  onNext: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  config: PropTypes.objectOf(PropTypes.any).isRequired
};

export default ModalForm;
